import actionHelpers from '../../utils/action-helpers';
// import getterHelpers from '../../utils/getter-helpers';
import mutationHelpers from '../../utils/mutation-helpers';
const path = process.env.VUE_APP_ROOT_API;

const state = {
  status: null,
  items: [],
  errors: []
};

// getters
const getters = {
  getAll: state => () => {
    return state.items;
  },
  getById: state => id => {
    return state.items.find(o => {
      return o.id === parseInt(id, 10);
    });
  },
  getByUser: state => id => {
    return state.items.filter(o => {
      return o.user_id === parseInt(id, 10);
    });
  }
};

// actions
const actions = {
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
  CLEAR_ITEMS: ({ commit }) => {
    commit('CLEAR_ITEMS');
  },
  FETCH_ALL_USER: ({ commit, dispatch }, { id, num }) => {
    // fetch an initial list of ponies
    commit('CLEAR_ITEMS');

    actionHelpers.FETCH_ALL(`${path}/api/user/${id}/activity/${num}`)({
      commit,
      dispatch
    });
  },
  FETCH_ALL: ({ commit, dispatch }, { num }) => {
    // fetch an initial list of ponies
    commit('CLEAR_ITEMS');

    actionHelpers.FETCH_ALL(`${path}/api/activity/${num}`)({
      commit,
      dispatch
    });
  }
};

// mutations
const mutations = {
  UPDATE_STATUS: mutationHelpers.UPDATE_STATUS,
  RESET_ERRORS: mutationHelpers.RESET_ERRORS,
  SET_ERROR: mutationHelpers.SET_ERROR,
  CLEAR_ITEMS(state) {
    state.items = [];
  },
  SET_ITEMS: (state, data) => {
    state.items = data.data.items;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
